import AnalysisPage from './AnalysisPage';

// React Admin Resource Configuration
const AnalysisResource = {
    name: 'Analysis',
    list: AnalysisPage,
    options: { label: 'Analysis' }
};

export default AnalysisResource;
